import { useEffect, useRef, useState } from "react";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall } from "../CommonComponents/CustomHooks";
import Loader from "../CommonComponents/Loader";

const ForgotPasswordSlide2 = () => {
    let url = window.location.search;
    const queryString = new URLSearchParams(url);
    const ForgetUserCode = queryString.get('UserCode');
    const ForgetToken = queryString.get('Token');
    const LoginType = queryString.get('Type')
    const navigate = useNavigate();
    const [user, setUser] = useState({
        NewPassword: '', ConfirmPassword: '', ForgetUserCode: ForgetUserCode, LoginType: LoginType
    });
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const inputrefs = useRef([]);

    //Recipe Change Handler
    const HandleChange = (prop, value) => {
        setUser(user => ({ ...user, [prop]: value }))
    }
    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };
    //submit button Handler
    const HandleSubmit = async () => {
        setIsLoading(true);
        const data = {
            ...user,
            ForgetToken, 
        }
        let res = await ApiCall(`/api/Login/UpdateForgotPassword`, data)
        if (res.status === 'SUCCESS') {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
            navigate('/')
            setUser(user => ({ ...user, NewPassword: '', ConfirmPassword: '' }))
        } else {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };
   
    useEffect(() => {
        document.title = 'Forget Password'
    }, [])
    return (
        <>
            <section className='login-page'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 px-0">
                            <div className="login-image">
                                <img src="https://portal.cppwebservices.in/Content/Login/img/logo.png?v=2" alt="Logo" />
                                <h3>Welcome to <br />CPP Login Panel</h3>
                                <p className="top">Your one stop platform for</p>
                                <p>CPP Membership</p>
                            </div>
                        </div>
                        <div className="col-lg-6 p-0 col-md-12 d-flex justify-content-between flex-column align-items-center">
                            <div className="aboutSec otpSec">
                                <div className="otpSecLft loginLft">
                                    <div className='ram'>
                                        <h2 className="logTitle">Forgot Password</h2>
                                        <div className="loginpSec mb-10 position-relative">
                                            <label htmlFor="txtUserCode" className="form-label lbl"> User Code</label>
                                            <input
                                                className="form-control txtField username"
                                                id="txtUserCode"
                                                ref={ref => (inputrefs.current['txtUserCode'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { inputrefs.current['txtPassword'].focus() };
                                                }}
                                                placeholder={LoginType === 'Dealer' ? 'Dealer' : 'User Code'}
                                                maxLength="15"
                                                autoComplete="off"
                                                value={ForgetUserCode ? ForgetUserCode : ""}
                                                disabled={ForgetUserCode}
                                                onChange={(e) => HandleChange('UserCode', e.target.value)}
                                            />
                                        </div>
                                        <div className="loginpSec mb-10 position-relative">
                                            <label className="form-label lbl">New Password <span className='required'>*</span></label>
                                            <input
                                                type={showPassword.NewPassword ? 'text' : 'password'}
                                                className="form-control txtField username"
                                                id="txtNewPassword"
                                                ref={ref => (inputrefs.current['txtNewPassword'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { inputrefs.current['txtconfirmPassword'].focus() };
                                                }}
                                                placeholder="New Password"
                                                name='New Password'
                                                value={user.NewPassword}
                                                onChange={(e) => HandleChange('NewPassword', e.target.value)}
                                            />
                                            <span style={{ position: "absolute", right: "10px", top: "65%", transform: 'translateY(-58%)', cursor: "pointer" }} onClick={() => handleTogglePassword('NewPassword')}>
                                                {!showPassword.NewPassword ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                            </span>
                                        </div>

                                        <div className="loginpSec mb-10 position-relative">
                                            <label className="form-label lbl">Confirm Password <span className='required'>*</span></label>
                                            <input
                                                type={showPassword.ConfirmPassword ? 'text' : 'password'}
                                                className="form-control txtField username"
                                                id="txtconfirmPassword"
                                                ref={ref => (inputrefs.current['txtconfirmPassword'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { inputrefs.current['btnSubmit'].focus() };
                                                }}
                                                placeholder="Confirm Password"
                                                name='Confirm Password'
                                                value={user.ConfirmPassword}
                                                onChange={(e) => HandleChange('ConfirmPassword', e.target.value)}
                                            />
                                            <span style={{ position: "absolute", right: "10px", top: "65%", transform: 'translateY(-58%)', cursor: "pointer" }} onClick={() => handleTogglePassword('ConfirmPassword')}>
                                                {!showPassword.ConfirmPassword ? <FaEyeSlash className='eyeIcon' /> : <FaEye className='eyeIcon' />}
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            ref={ref => (inputrefs.current['btnSubmit'] = ref)}
                                            id="btnSubmit"
                                            className="pageBtn otpBtn btn-login"
                                            onClick={HandleSubmit}
                                        >
                                            Reset Forgot Password
                                        </button>
                                    </div>
                                </div>
                                {isLoading && (<Loader />)}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default ForgotPasswordSlide2;